(function($){

	"use strict";

	/**
	 * BrickWall Object
	 */

	var BrickWall = function (wall) {
		this.wall = $(wall);
		this.wall.data('brickWall', this);
		this.init();
	};

	BrickWall.prototype = {

		constructor: BrickWall,

		init: function() {

			var that = this;

			this.bricks = this.wall.find('.brick');
			this.indicatorContainer = this.wall.siblings('.brick-wall-indicators');
			this.indicators = this.indicatorContainer.find('.brick-wall-indicators__button');

			this.bricksPerSlide = {
				xs: 2,
				sm: 4,
				md: 6,
				lg: 8,
				xl: 8
			};

			this.slideOrder = {
				xs: [1, 2],
				sm: [1, 2, 3, 4],
				md: [1, 2, 3, 5, 6, 4],
				lg: [1, 2, 3, 4, 5, 6, 7, 8],
				xl: [1, 2, 3, 4, 5, 6, 7, 8]
			};

			this.play = null;
			this.isSliding = false;
			this.isPlaying = false;
			this.panStarted = false;
			this.previousBreakpoint = null;

			this.defaultStartSlide = null;
			this.defaultNextSlide = null;

			this.setCurrentSlide(this.getDefaultStartSlide());
			this.setNextSlide(this.getDefaultNextSlide());

			this.slideTimeout = 6000;
			this.panTransitionArea = 0.1; // percentage. do not exceed 1.
			this.deltaX = 0;
			this.relativeDeltaX = 0;

			this
				.groupBricks()
				.updateCurrentAndNextBricks()
				.createIndicators()
				.createBrickWindows()
				.registerLinkEventPropagation()
				.registerBreakpointEvents(window.breakpoint)
				.callWhatsAppSharingCode()
				.recalculateBrickDescriptionExcerpt()
			;

			this.wall.hammer();

			$(window)
				.on('load resize', function () {
					that.recalculateBrickDescriptionExcerpt();
				})
				.on('breakpointChange.brickwall', function() {
					that.breakpointChange().playSlider();
				})
				.on('focus.brickwall', function () {
					that.playSlider();
				})
				.on('blur.brickwall', function () {
					that.stopSlider();
				})
			;

			if (isBreakpoint('xs')) {
				this.initPanSlider();
			}
			// else {
			// 	$(window).one('load', function () {
			// 		if (!isBreakpoint('xs')) {
			// 			that.playSlider();
			// 		}
			// 	});
			// }

		},

		reset: function () {
			this.setCurrentSlide(this.getDefaultStartSlide())
				.setNextSlide(this.getDefaultNextSlide())
				.removeFlipClasses()
				.stopSlider()
				.flushPanSlider()
				.groupBricks()
				.recalculateBrickDescriptionExcerpt()
				.updateCurrentAndNextBricks()
				.createIndicators();

			return this;
		},

		breakpointChange: function () {
			this.reset();

			if (this.isSliding) {
				this.finishFlip();
			}

			if (isBreakpoint('xs')) {
				this.registerBreakpointEvents('xs');
				this.initPanSlider();
			}
			else if (this.previousBreakpoint == 'xs') {
				this.registerBreakpointEvents(window.breakpoint);
			}

			this.previousBreakpoint = window.breakpoint;

			return this;
		},

		registerBreakpointEvents: function (breakpoint) {
			var that = this;

			if (breakpoint == 'xs') {
				this.wall
					.off('mouseenter.brickwall mouseleave.brickwall')
					.on('panstart.brickwall', function (event) {
						that.panStart(event);
					})
					.on('panright.brickwall panleft.brickwall', function (event) {
						that.pan(event);
					})
					.on('panend.brickwall', function () {
						that.panEnd();
					});
			}
			else {
				this.wall
					.off('panstart.brickwall panright.brickwall panleft.brickwall panend.brickwall')
					.on('mouseenter.brickwall', function () {
						that.stopSlider();
					})
					.on('mouseleave.brickwall', function () {
						that.playSlider();
					});
			}

			return this;
		},

		unregisterBreakpointEvents: function () {
			this.wall
				.off('panstart.brickwall panright.brickwall panleft.brickwall panend.brickwall ' +
					'mouseenter.brickwall mouseleave.brickwall');
		},

		getAvailableBricks: function() {
			return this.bricks.filter('[data-available-at*="' + window.breakpoint + '"]');
		},

		getBricksPerSlide: function () {
			return this.bricksPerSlide[window.breakpoint];
		},

		createIndicators: function() {
			var that = this;

			var baseIndicator = this.indicators.first().clone();

			this.indicators.remove();

			for (var i = 1; i <= this.getTotalSlides(); i++) {
				this.indicatorContainer.append(baseIndicator.clone().attr('data-brick-slide', i));
			}

			this.indicators = this.indicatorContainer.find('.brick-wall-indicators__button');

			this.indicators.on('click.brickwall', function () {
				if (isBreakpoint('xs')) {
					that.panTo($(this).data('brick-slide'));
				}
				else {
					that.flipTo($(this).data('brick-slide'));
				}

				return false;
			});

			this.updateIndicatorsState();

			return this;
		},

		updateIndicatorsState: function(slideNumber) {
			if (typeof slideNumber == 'undefined') {
				slideNumber = this.getCurrentSlide();
			}

			this.indicators.removeClass('active');
			this.indicators.eq(slideNumber - 1).addClass('active');

			return this;
		},

		registerLinkEventPropagation: function () {
			this.bricks.each(function () {
				var links = $(this).find('.brick__link');

				if ($(this).hasClass('brick--alert-a')) {
					links = links.add($(this).siblings('.brick--alert-b').find('.brick__link'));
				}

				if (!$(this).hasClass('brick--alert-b')) {
					links
						.on('mouseenter.link.brickwall', function () {
							links.addClass('hover');
						})
						.on('mouseleave.link.brickwall', function () {
							links.removeClass('hover');
						})
						.on('focus.link.brickwall', function () {
							links.addClass('focus');
						})
						.on('blur.link.brickwall', function () {
							links.removeClass('focus');
						})
						.on('mousedown.link.brickwall', function () {
							links.addClass('active');
						})
						.on('mouseup.link.brickwall', function () {
							links.removeClass('active');
						});
				}
			});

			return this;
		},

		groupBricks: function() {
			var that = this;

			this.bricks.removeAttr('data-brick-group data-brick-slide');

			var i = 0;

			this.getAvailableBricks().each(function(){
				var slideNumber = (parseInt(i / that.getBricksPerSlide()) + 1);

				if (isBreakpoint('xs')) {
					$(this).is('.brick--img') ? $(this).attr('data-brick-group', 1) : $(this).attr('data-brick-group', 2);
				}
				else {
					$(this).attr('data-brick-group', ((i % that.getBricksPerSlide()) + 1));
				}

				$(this).attr('data-brick-slide', slideNumber);

				i++;
			});

			return this;
		},

		updateCurrentAndNextBricks: function() {
			var availableBricks = this.getAvailableBricks();

			this.currentBricks = availableBricks.filter('[data-brick-slide="' + this.currentSlide + '"]');
			this.nextBricks = availableBricks.filter('[data-brick-slide="' + this.nextSlide + '"]');

			if (this.nextBricks.length == 0) {
				this.nextBricks = availableBricks.filter('[data-brick-slide="1"]');
				this.setNextSlide(1);
			}

			this.bricks.removeClass('current next');
			this.currentBricks.addClass('current');
			this.nextBricks.addClass('next');

			return this;
		},

		getTotalSlides: function () {
			return Math.floor(this.getAvailableBricks().length / this.getBricksPerSlide());
		},

		createBrickWindows: function() {
			this.bricks.find('.brick__face').each(function () {
				$(this).clone().appendTo($(this).parent());
			});

			this.bricks.find('.brick__face').wrap('<div class="brick__window"/>');

			this.bricks.find('.brick__window').append('<i class="brick__window-shadow"/>');

			this.bricks.find('.brick__window').each(function () {
				$(this).addClass('brick__window--' + ($(this).index() + 1));

				if ($(this).index() == 1) {
					$(this).add($(this).find('*')).attr('tabindex', '-1');
				}
			});

			return this;
		},

		flip: function () {

			if (this.isSliding) {
				return this;
			}

			this.isSliding = true;

			this.getAvailableBricks().removeClass('slideback');

			this.updateIndicatorsState(this.getNextSlide());

			this.recalculateBrickDescriptionExcerpt();

			this.flipBricks().playSlider();

			return this;

		},

		flipTo: function (slideNumber) {
			if (slideNumber == this.getCurrentSlide() || this.isSliding) {
				return this;
			}

			this.setNextSlide(slideNumber)
				.stopSlider()
				.updateCurrentAndNextBricks()
				.flip();

			return this;
		},

		playSlider: function() {
			var that = this;

			if (this.isPlaying == true || isBreakpoint('xs')) {
				return this;
			}

			this.isPlaying = true;

			this.play = setTimeout(function () {
				that.isPlaying = false;
				that.flip();
			}, this.slideTimeout);

			return this;
		},

		stopSlider: function() {
			clearTimeout(this.play);
			this.play = null;
			this.isPlaying = false;

			return this;
		},

		flipBricks: function () {
			var that = this;

			this.wall.trigger('flipStart');

			var _flip = function (i) {
				var duration = parseFloat(that.currentBricks.filter('[data-brick-group="' +
					that.slideOrder[window.breakpoint][i] + '"]').css('transition-duration'));

				that.play = setTimeout(function () {
					that.currentBricks.add(that.nextBricks).filter('[data-brick-group="' +
						that.slideOrder[window.breakpoint][i] + '"]').addClass('slide');

					if ((i + 1) == that.getBricksPerSlide()) {
						setTimeout(function () {
							that.finishFlip();
						}, duration * 1000 + 100);
					}
				}, (duration * 300 * i));
			};

			for (var i = 0; i < this.getBricksPerSlide(); i++) {
				_flip(i);
			}

			return this;
		},

		finishFlip: function () {
			this.currentBricks.addClass('slideback');
			this.getAvailableBricks().removeClass('slide right left');

			this.setCurrentSlide(this.getNextSlide())
				.setNextSlide(this.getCurrentSlide() + 1)
				.updateCurrentAndNextBricks();

			this.isSliding = false;

			this.wall.trigger('flipEnd');

			return this;
		},

		removeFlipClasses: function () {
			this.wall.hide();
			this.wall.width(0);
			this.bricks.removeClass('current next slide slideback right left');
			this.wall.width('auto');
			this.wall.show();

			return this;
		},

		initPanSlider: function () {
			var totalWidth = (this.getTotalSlides() * 100);
			var brickWidth = (100 / this.getTotalSlides());

			this.wall.width(totalWidth + '%');

			this.getAvailableBricks().each(function () {
				$(this).css({
					'margin-left': (($(this).data('brick-slide') - 1) * brickWidth) + '%',
					'padding-top': brickWidth + '%',
					'width': brickWidth + '%'
				});
			});

			return this;
		},

		panStart: function () {
			if (!isBreakpoint('xs')) {
				return this;
			}

			this.relativeDeltaX = this.deltaX;
			this.panStarted = true;

			this.wall.stop();

			return this;
		},

		pan: function (event) {
			if (this.panStarted) {
				var deltaX = (event.gesture.deltaX + this.relativeDeltaX);

				this.wall.css({
					//'-webkit-transform' : 'translateX(' + deltaX + 'px)',
					//'-moz-transform' : 'translateX(' + deltaX + 'px)',
					//'transform' : 'translateX(' + deltaX + 'px)',
					'left': deltaX
				});

				this.deltaX = deltaX;
			}

			return this;
		},

		panTo: function (slideNumber) {
			var that = this;

			var brickWidth = (this.wall.width() / this.getTotalSlides());
			var slidePosition = brickWidth * (-slideNumber + 1);

			this.wall.stop().animate(
				{ 'left': slidePosition },
				{
					step: function (now, tween) {
						that.deltaX = now;
					},
					complete: function () {
					}
				});

			this
				.setCurrentSlide(slideNumber)
				.updateIndicatorsState();

			return this;
		},

		panEnd: function () {
			if (this.panStarted) {
				this.panStarted = false;

				var brickWidth = (this.wall.width() / this.getTotalSlides());
				var slidePosition = -(brickWidth * (this.getCurrentSlide() - 1));

				var transitionArea = this.panTransitionArea * brickWidth;

				if ((this.deltaX > -(this.wall.width() - brickWidth)) && (this.deltaX < (slidePosition - transitionArea))) {
					this.panTo(this.getCurrentSlide() + 1);
				}
				if ((this.deltaX < 0) && (this.deltaX > (slidePosition + transitionArea))) {
					this.panTo(this.getCurrentSlide() - 1);
				}
				else {
					this.panTo(this.getCurrentSlide());
				}
			}

			return this;
		},

		flushPanSlider: function () {
			this.deltaX = 0;
			this.relativeDeltaX = 0;

			this.wall.css({
				//'-webkit-transform': 'translateX(0)',
				//'-moz-transform': 'translateX(0)',
				//'transform': 'translateX(0)',
				'left': 0
			});

			this.bricks.removeAttr('style');

			return this;
		},

		getDefaultStartSlide: function() {
			if (this.defaultStartSlide === null) {
				this.defaultStartSlide = 1;
			}

			return this.defaultStartSlide;
		},

		getDefaultNextSlide: function() {
			if (this.defaultNextSlide === null) {
				this.defaultNextSlide = 2;
			}

			return this.defaultNextSlide;
		},

		getCurrentSlide: function () {
			return this.currentSlide;
		},

		setCurrentSlide: function (slideNumber) {
			this.currentSlide = slideNumber;

			return this;
		},

		getNextSlide: function () {
			return this.nextSlide;
		},

		setNextSlide: function (slideNumber) {
			this.nextSlide = slideNumber;

			return this;
		},

		callWhatsAppSharingCode: function () {
			$('.brick--social .brick__window--1 .brick__franchisee-social-share-box--whatsapp').remove();
			if(typeof window.wabtn4fg === "undefined"){
				window.wabtn4fg = 1;
				var h = document.head || document.getElementsByTagName("head")[0],
					s = document.createElement("script");
				s.type = "text/javascript";
				s.src = window.appConfig.websiteBaseUrlWithoutLanguage + "/app/themes/sportball-v3/assets/js/plugins/whatsapp-sharing/dist/whatsapp-button.js";
				h.appendChild(s);
			}

			return this;
		},

		recalculateBrickDescriptionExcerpt: function () {
			$('.brick').each(function () {
				var descriptionTags = $(this).find('.brick__description');

				if (descriptionTags.length > 0) {
					var firstDescriptionTag = descriptionTags.first();
					var lineHeight = parseFloat(firstDescriptionTag.css('line-height'));
					var topPosition = firstDescriptionTag.prev().length === 1 ?
						firstDescriptionTag.prev().position().top + firstDescriptionTag.prev().outerHeight() : 0;
					var buttonElement = firstDescriptionTag.parent().find('.brick__link');
					var buttonPosition = buttonElement.length ? buttonElement.position().top : buttonElement.parent().height();
					var bottomMargin = parseInt(firstDescriptionTag.css('margin-bottom'));
					var remainingHeight = buttonPosition - topPosition - bottomMargin;
					var maxLines = Math.floor(remainingHeight / lineHeight);

					// Store the original text
					if (!firstDescriptionTag.data('originalText')) {
						firstDescriptionTag.data('originalText', firstDescriptionTag.text().replace(/\s+/, ' '));
					}

					var resultingText = firstDescriptionTag.data('originalText');

					// Append the rule before the original element, make it absolute positioned, invisible and empty
					var ruler = $('<div>')
						.css({
							'position': 'absolute',
							'visibility': 'hidden',
							'font': firstDescriptionTag.css('font'),
							'white-space': 'nowrap'
						})
						.insertBefore(firstDescriptionTag);

					firstDescriptionTag.html(firstDescriptionTag.data('originalText'));

					if (firstDescriptionTag.height() > (maxLines * lineHeight)) {

						resultingText = '';

						if ((maxLines > 0) && firstDescriptionTag.data('originalText').length > 0) {
							// Get original element's dimensions
							var originalWidth = firstDescriptionTag.width();

							// Get the text and split it into an array of words
							var words = firstDescriptionTag.data('originalText').split(' ');

							// Line counter
							var lines = 1;

							var ending = '…';

							var punctuation = /[\.,\/#!\$%\^&\*;:\{}=\-_…`~\(\)]$/;

							// Add each word, one by one, until the ruler's width is equal to the original element's width
							for (var i = 0; i < words.length; i++) {
								var word = words[i];
								// We begin using .html() here because there may be <br>'s already added in another pass
								var currentText = ruler.html();

								var isMaxLine = (lines === maxLines);
								var isLastWord = ((i + 1) === words.length);

								ruler.html(currentText + ' ' + word + (isMaxLine && !isLastWord ? ending : ''));

								var rulerIsWider = (ruler.width() >= originalWidth);

								if (rulerIsWider) {
									if (isMaxLine) {
										ruler.html(currentText.replace(punctuation, '') + ending);
										resultingText += ' ' + ruler.html();
										break;
									}
									else {
										ruler.html(word);
										resultingText += ' ' + currentText;
										lines++;
									}
								}
								else if (isLastWord) {
									resultingText += ' ' + ruler.html();
								}
								else {
									ruler.html(currentText + ' ' + word);
								}
							}
						}
					}

					descriptionTags.html(resultingText);

					ruler.remove();
				}
			});

			return this;
		}

	};

	$('.brick-wall').each(function () {
		var brickWall = new BrickWall($(this));
	});

})(window.jQuery);
